import { createFileRoute } from '@tanstack/react-router';

import { SignGroupDetailsRoute } from '@/routes/_authenticated/_management/verkehrszeichen/$adminLevelId/-SignGroupDetailsRoute';

export const Route = createFileRoute(
  '/_authenticated/_management/verkehrszeichen/$adminLevelId/$signSupportId_/$signGroupId_/$signId',
)({
  component: SignGroupDetailsRoute,
});
